import { render, staticRenderFns } from "./DirectionsLink.vue?vue&type=template&id=c60bd7a8&scoped=true&"
import script from "./DirectionsLink.vue?vue&type=script&lang=ts&"
export * from "./DirectionsLink.vue?vue&type=script&lang=ts&"
import style0 from "./DirectionsLink.vue?vue&type=style&index=0&id=c60bd7a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60bd7a8",
  null
  
)

export default component.exports